import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { withTranslation, Trans } from 'react-i18next';
import Heading from '../../components/heading/heading';
import './pledge.scss';

class Pledge extends React.Component {

  render() {

    //const SPAN = 7;
    //const LEFT = 0;
    //const RIGHT = 5;

    const { t } = this.props;
    return <>
    <Row><Col>

  <Trans i18nKey='OurPledge._intro'>
    <div className="pledge-intro">
<p>
Our goal is to help you reach your goals and be the best athlete you can possibly be.
</p>
<p>
For that,</p>
</div>
</Trans>
<Heading as="h1" className="page">{t('OurPledge._headline')}</Heading>
  
  </Col></Row>
  
  
  <Row>
    <Col md={4}>
    <Heading as="h2" type="section" className="text-right">{t('OurPledge.open_headline')}</Heading>
    </Col>
    <Col md={8}>
    <p>{t('OurPledge.open_body')}</p>
    </Col>

</Row>

<Row>
    <Col md={4}>
    <Heading as="h2" type="section" className="text-right">{t('OurPledge.transparent_headline')}</Heading>
    </Col>
    <Col md={8}>
    <p>{t('OurPledge.transparent_body')}</p>
    </Col>

</Row>

<Row>
    <Col md={4}>
    <Heading as="h2" type="section" className="text-right">{t('OurPledge.supportive_headline')}</Heading>
    </Col>
    <Col md={8}>
    <p>{t('OurPledge.supportive_body')}</p>
    </Col>

</Row>

<Row>
    <Col md={4}>
    <Heading as="h2" type="section" className="text-right">{t('OurPledge.inclusive_headline')}</Heading>
    </Col>
    <Col md={8}>
    <p>{t('OurPledge.inclusive_body')}</p>
    </Col>

</Row>

<Row>
    <Col md={4}>
    <Heading as="h2" type="section" className="text-right">{t('OurPledge.sustainable_headline')}</Heading>
    </Col>
    <Col md={8}>
    <p>{t('OurPledge.sustainable_body')}</p>
    </Col>

</Row>




    </>
  }
}
export default withTranslation()(Pledge);